import { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useFolders } from '../../hooks/useFolder';
import { DashboardMenu, MyFoldersMenu } from '../components';
import { GridIcon, FolderIcon, TrashIcon } from '../icons';

const DashboardMenuView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState('dashboard');

    // Dashboard menu items
    const menuItems = useMemo(() => [
    {
      id: 'dashboard',
      label: 'Explore',
      icon: GridIcon,
      route: '/',
      children: [
        {
          id: 'folders',
          label: 'Folders',
          icon: FolderIcon,
          route: '/',
          children: []
        },
        {
          id: 'items',
          label: 'Items',
          icon: FolderIcon,
          route: '/items',
          children: []
        },
      ]
    },
    {
      id: 'trash',
      label: 'Trash Bin',
      icon: TrashIcon,
      route: '/trash',
      children: []
    },
  ], []);

    // Sync active item with current route
    useEffect(() => {
        const currentItem = menuItems.find(item => 
            item.route === location.pathname || 
            (item.children && item.children.some(child => child.route === location.pathname))
        );
        if (currentItem) {
            setActiveItem(currentItem.id);
        }
    }, [location.pathname, menuItems]);

    const handleItemClick = (item) => {
        setActiveItem(item.id);
        if (item.route) {
            navigate(item.route);
        }
    };

    return (
        <DashboardMenu
            items={menuItems}
            activeItemId={activeItem}
            onItemClick={handleItemClick}
        />
    );
};

const MyFoldersMenuView = () => {
    const { folders, createFolder } = useFolders();
    const { clipboardId: currentFolderId } = useParams();
    const navigate = useNavigate();

    const handleFolderSelect = (folder) => {
        console.log('Selected folder:', folder);
        navigate(`/my/folder/${folder.id}`);
    };

    const handleNewFolder = async (name) => {
        try {
            await createFolder({ name });
            // if (folder?.id) {
            //     navigate(`/v2/folder/${folder.id}`);
            // }
        } catch (e) {
            // Error is already toasted in hook
        }
    };

    return (
        <MyFoldersMenu
            folders={folders}
            currentFolderId={currentFolderId}
            onFolderSelect={handleFolderSelect}
            onNewFolder={handleNewFolder}
        />
    );
};

export { DashboardMenuView, MyFoldersMenuView };